/**
 * @项目名称: work
 * @功能名称:
 * @文件名称: xreportPage
 * @Date: 2019/11/25
 * @Author: liux
 * @Copyright（C）2019 「小赢科技」 Inc.   All rights reserved.
 * 注意：本内容仅限于「小赢科技」内部传阅，禁止外泄以及用于其他的商业目的。
 */
function isMobileBrowser () {
  return /Mobile/i.test(navigator.userAgent)
}
export default function (router, report) {
  /**
   * 进入前先上报上个页面的离开事件 page_hide pageOnTime
   */
  router.beforeEach((to, from, next) => {
    if(from && from.path){
      let data = from && from.meta && from.meta.report || {};
      report.pageHide(data)
    }
    next()
  })
  /**
   * 进入页面初始化上报页面pv
   */
  router.afterEach((to, from) => {
    setTimeout(()=>{
      if(!to.meta){
        to.meta = {}
      }
      if(!to.meta.report){
        to.meta.report = {}
      }
      if(!to.meta.report.pageId){
        to.meta.report.pageId = report.createUniqueString()
      }
      report.pageShow(to.meta.report)
    }, 0)
  })

  /**
   * 监听浏览器窗口关闭事件
   */
  if (isMobileBrowser()) {
    document.addEventListener('visibilitychange', function () {
      if (document.visibilityState === "hidden") {
        let meta =  router.currentRoute && router.currentRoute.meta
        let data = (meta && meta.report) || {}
        (!data.disable || !data.eventName) && report.pageHide(data)
      }
      if(document.visibilityState === "visible"){
        let meta =  router.currentRoute && router.currentRoute.meta
        let data = (meta && meta.report) || {}
        report.pageShow(data)
      }
    })
  } else {
    window.addEventListener('beforeunload', function () {
      let meta =  router.currentRoute && router.currentRoute.meta
      let data = (meta && meta.report) || {}
      !data.disable && report.pageHide(data)
    })
  }
}
